// import React, { useState } from "react";
// import axios from "axios";
// import { Link, useNavigate } from "react-router-dom";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import { message } from "antd";

// const CLOUD_NAME = "dmtwtt5mz";
// const UPLOAD_PRESET = "provider_gallery_upload";
// const CLOUDINARY_API = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`;

// const Register = () => {
//   const [registerData, setRegistrationData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     phoneNumber: "",
//     password: "",
//     role: "",
//     address: "",
//     category: "",
//     avatar: null,
//   });

//   const [avatarPreview, setAvatarPreview] = useState(null);
//   const [showPassword, setShowPassword] = useState(false);
//   const navigate = useNavigate();

//   const handleChange = (event) => {
//     const { name, value, files } = event.target;

//     if (name === "avatar") {
//       const file = files[0];
//       if (file) {
//         setRegistrationData((prev) => ({
//           ...prev,
//           avatar: file,
//         }));
//         setAvatarPreview(URL.createObjectURL(file));
//       }
//     } else {
//       setRegistrationData((prev) => ({
//         ...prev,
//         [name]: value,
//       }));
//     }
//   };

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const {
//       firstName,
//       lastName,
//       email,
//       password,
//       phoneNumber,
//       role,
//       address,
//       category,
//       avatar,
//     } = registerData;

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

//     if (!firstName || !lastName || !email || !password || !role || !address) {
//       return message.error("All fields are required.");
//     }

//     if (role === "provider" && !category.trim()) {
//       return message.error("Category is required for service providers.");
//     }

//     if (!emailRegex.test(email)) {
//       return message.error("Please enter a valid email address.");
//     }

//     if (!passwordRegex.test(password)) {
//       return message.error("Password must include uppercase, lowercase, number, and special character.");
//     }

//     try {
//       let avatarUrl = "";

//       // Upload avatar to Cloudinary first
//       if (avatar && role === "provider") {
//         const formData = new FormData();
//         formData.append("file", avatar);
//         formData.append("upload_preset", UPLOAD_PRESET);
//         formData.append("folder", "provider-avatars");

//         const res = await fetch(CLOUDINARY_API, {
//           method: "POST",
//           body: formData,
//         });

//         const data = await res.json();

//         if (!data.secure_url) {
//           return message.error("Avatar upload failed.");
//         }

//         avatarUrl = data.secure_url;
//       }

//       // Now send user data to backend
//      const response = await axios.post(
//   `${API_BASE}/user/registers`,
//   {
//     firstName,
//     lastName,
//     email,
//     phoneNumber,
//     password,
//     role,
//     address,
//     category: role === "provider" ? category : undefined,
//     avatar: avatarUrl,
//   },
//   {
//     withCredentials: true, // ✅ Required for cookies/auth with CORS
//   }
// );


//       if (response.status === 201) {
//         message.success("You registered successfully.");
//         navigate("/login");
//       } else {
//         message.error(response.data?.message || "Registration failed.");
//       }
//     } catch (error) {
//       console.error("Registration error:", error);
//       const errorMessage = error.response?.data?.message || error.message || "Unknown error occurred.";
//       message.error(errorMessage);
//     }
//   };
// const API_BASE = process.env.REACT_APP_API_BASE;

//   return (
//     <div
//       className="flex items-center justify-center min-h-screen bg-cover bg-center p-5"
//       style={{
//         backgroundImage:
//           "url('https://images.unsplash.com/photo-1496307042754-b4aa456c4a2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1950&q=80')",
//       }}
//     >
//       <div className="w-full max-w-5xl p-8 border border-gray-300 rounded-md shadow-md bg-white bg-opacity-95">
//         <h2 className="text-center text-2xl mb-6 text-gray-800 font-semibold">Sign Up</h2>
//         <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
//           {/* Email */}
//           <div className="col-span-2">
//             <label className="block text-gray-700 mb-1">Email</label>
//             <input
//               type="email"
//               name="email"
//               value={registerData.email}
//               onChange={handleChange}
//               className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-500"
//             />
//           </div>

//           {/* First & Last Name */}
//           <div className="col-span-2 md:col-span-1">
//             <label className="block text-gray-700 mb-1">First Name</label>
//             <input
//               type="text"
//               name="firstName"
//               value={registerData.firstName}
//               onChange={handleChange}
//               className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-500"
//             />
//           </div>
//           <div className="col-span-2 md:col-span-1">
//             <label className="block text-gray-700 mb-1">Last Name</label>
//             <input
//               type="text"
//               name="lastName"
//               value={registerData.lastName}
//               onChange={handleChange}
//               className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-500"
//             />
//           </div>

//           {/* Phone */}
//           <div className="col-span-2">
//             <label className="block text-gray-700 mb-1">Phone Number</label>
//             <input
//               type="tel"
//               name="phoneNumber"
//               value={registerData.phoneNumber}
//               onChange={handleChange}
//               className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-500"
//             />
//           </div>

//           {/* Password */}
//           <div className="col-span-2 relative">
//             <label className="block text-gray-700 mb-1">Password</label>
//             <input
//               type={showPassword ? "text" : "password"}
//               name="password"
//               value={registerData.password}
//               onChange={handleChange}
//               className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-500"
//             />
//             <button
//               type="button"
//               onClick={togglePasswordVisibility}
//               className="absolute inset-y-0 right-3 top-8 flex items-center text-sm leading-5 text-gray-600"
//             >
//               {showPassword ? <FaEyeSlash /> : <FaEye />}
//             </button>
//           </div>

//           {/* Role Selection */}
//           <div className="col-span-2">
//             <label className="block text-gray-700 mb-2">Register As</label>
//             <div className="flex gap-6">
//               <label className="flex items-center space-x-2">
//                 <input
//                   type="radio"
//                   name="role"
//                   value="user"
//                   checked={registerData.role === "user"}
//                   onChange={handleChange}
//                   className="form-radio text-red-500"
//                 />
//                 <span>User</span>
//               </label>
//               <label className="flex items-center space-x-2">
//                 <input
//                   type="radio"
//                   name="role"
//                   value="provider"
//                   checked={registerData.role === "provider"}
//                   onChange={handleChange}
//                   className="form-radio text-red-500"
//                 />
//                 <span>Service Provider</span>
//               </label>
//             </div>
//           </div>

//           {/* Address */}
//           <div className="col-span-2">
//             <label className="block text-gray-700 mb-1">Address</label>
//             <input
//               type="text"
//               name="address"
//               value={registerData.address}
//               onChange={handleChange}
//               className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-500"
//             />
//           </div>

//           {/* Provider Fields */}
//           {registerData.role === "provider" && (
//             <>
//               <div className="col-span-2 md:col-span-1">
//                 <label className="block text-gray-700 mb-1">Category</label>
//                 <input
//                   type="text"
//                   name="category"
//                   value={registerData.category}
//                   onChange={handleChange}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-500"
//                 />
//               </div>

//               <div className="col-span-2 md:col-span-1">
//                 <label className="block text-gray-700 mb-1">Profile Image</label>
//                 <input
//                   type="file"
//                   name="avatar"
//                   accept="image/*"
//                   onChange={handleChange}
//                   className="w-full px-4 py-2 border border-gray-300 rounded-md"
//                 />
//               </div>

//               {avatarPreview && (
//                 <div className="col-span-2 text-center">
//                   <p className="text-gray-700 mb-1">Preview:</p>
//                   <img
//                     src={avatarPreview}
//                     alt="Preview"
//                     className="h-32 w-32 object-cover rounded-full mx-auto"
//                   />
//                 </div>
//               )}
//             </>
//           )}

//           <div className="col-span-2">
//             <button
//               type="submit"
//               className="w-full py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
//             >
//               Sign Up
//             </button>
//           </div>

//           <div className="col-span-2 text-center mt-4">
//             <p className="text-gray-700">
//               <Link to="/login">
//                 <button className="text-red-500 hover:underline">
//                   Already have an account? Sign In
//                 </button>
//               </Link>
//             </p>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Register;
import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { message } from "antd";

const CLOUD_NAME = "dmtwtt5mz";
const UPLOAD_PRESET = "provider_gallery_upload";
const CLOUDINARY_API = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`;
const API_BASE = process.env.REACT_APP_API_BASE;

const Register = () => {
  const [registerData, setRegistrationData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    role: "user",
    address: "",
    category: "",
    avatar: null,
  });

  const [avatarPreview, setAvatarPreview] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // 🚨 NEW LOADING STATE
  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value, files } = event.target;

    if (name === "avatar") {
      const file = files[0];
      if (file) {
        setRegistrationData((prev) => ({
          ...prev,
          avatar: file,
        }));
        setAvatarPreview(URL.createObjectURL(file));
      }
    } else if (name === "role" && value !== "provider") {
       setRegistrationData((prev) => ({
        ...prev,
        [name]: value,
        category: "",
        avatar: null,
      }));
      setAvatarPreview(null);
    } else {
      setRegistrationData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const {
      firstName,
      lastName,
      email,
      password,
      confirmPassword,
      phoneNumber,
      role,
      address,
      category,
      avatar,
    } = registerData;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

    if (!firstName || !lastName || !email || !password || !confirmPassword || !role || !address || !phoneNumber) {
      return message.error("All required fields must be filled.");
    }

    if (password !== confirmPassword) {
      return message.error("Passwords do not match.");
    }
    
    if (role === "provider" && !category.trim()) {
      return message.error("Category is required for service providers.");
    }

    if (!emailRegex.test(email)) {
      return message.error("Please enter a valid email address.");
    }

    if (!passwordRegex.test(password)) {
      return message.error("Password must include uppercase, lowercase, number, and special character.");
    }
    
    // 🚨 START LOADING
    setIsLoading(true);

    try {
      let avatarUrl = "";

      // Upload avatar to Cloudinary first
      if (avatar && role === "provider") {
        const formData = new FormData();
        formData.append("file", avatar);
        formData.append("upload_preset", UPLOAD_PRESET);
        formData.append("folder", "provider-avatars");

        const res = await fetch(CLOUDINARY_API, {
          method: "POST",
          body: formData,
        });

        const data = await res.json();

        if (!data.secure_url) {
          // 🚨 STOP LOADING ON FAILURE
          setIsLoading(false);
          return message.error("Avatar upload failed.");
        }

        avatarUrl = data.secure_url;
      }

      // Send user data to backend
      const response = await axios.post(
        `${API_BASE}/user/registers`,
        {
          firstName,
          lastName,
          email,
          phoneNumber,
          password,
          role,
          address,
          category: role === "provider" ? category : undefined,
          avatar: avatarUrl,
        },
        {
          withCredentials: true,
        }
      );

      if (response.status === 201) {
        message.success("You registered successfully.");
        navigate("/login");
      } else {
        message.error(response.data?.message || "Registration failed.");
      }
    } catch (error) {
      console.error("Registration error:", error);
      const errorMessage = error.response?.data?.message || error.message || "Unknown error occurred.";
      message.error(errorMessage);
    } finally {
      // 🚨 STOP LOADING REGARDLESS OF SUCCESS/FAILURE
      setIsLoading(false);
    }
  };

  // 4. UPDATED JSX (Adding Loader Component)
  return (
    <>
      {isLoading && <FullScreenLoader />} {/* 🚨 Render loader conditionally */}

      <div
        className="flex items-center justify-center min-h-screen bg-cover bg-center p-5"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1496307042754-b4aa456c4a2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1950&q=80')",
        }}
      >
        <div className="w-full max-w-5xl p-8 border border-gray-300 rounded-md shadow-lg bg-white bg-opacity-95">
          
          <div className="mb-6">
            <h1 className="text-xl font-bold text-green-700">MF Blind</h1>
            <p className="text-sm text-green-700">Registration Portal</p>
          </div>
          <h2 className="text-xl mb-6 text-gray-800 font-semibold">Sign Up</h2>

          <form onSubmit={handleSubmit} className="space-y-6">

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <InputField label="First Name*" name="firstName" value={registerData.firstName} onChange={handleChange} disabled={isLoading} />
              <InputField label="Last Name*" name="lastName" value={registerData.lastName} onChange={handleChange} disabled={isLoading} />
              <InputField label="Email*" name="email" type="email" value={registerData.email} onChange={handleChange} disabled={isLoading} />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <InputField label="Phone Number*" name="phoneNumber" type="tel" value={registerData.phoneNumber} onChange={handleChange} disabled={isLoading} />
              <InputField label="Address*" name="address" value={registerData.address} onChange={handleChange} disabled={isLoading} />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <PasswordField 
                label="Password*" 
                name="password" 
                value={registerData.password} 
                onChange={handleChange} 
                showPassword={showPassword} 
                togglePasswordVisibility={togglePasswordVisibility} 
                disabled={isLoading}
              />
              <PasswordField 
                label="Confirm Password*" 
                name="confirmPassword" 
                value={registerData.confirmPassword} 
                onChange={handleChange} 
                showPassword={showPassword} 
                togglePasswordVisibility={togglePasswordVisibility} 
                disabled={isLoading}
              />
            </div>
            
            <div className="border-t pt-6">
              <div className="col-span-2 mb-4">
                <label className="block text-gray-700 font-medium mb-2">Register As*</label>
                <div className="flex gap-6">
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="role"
                      value="user"
                      checked={registerData.role === "user"}
                      onChange={handleChange}
                      className="form-radio text-green-700" 
                      disabled={isLoading}
                    />
                    <span>User</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="role"
                      value="provider"
                      checked={registerData.role === "provider"}
                      onChange={handleChange}
                      className="form-radio text-green-700" 
                      disabled={isLoading}
                    />
                    <span>Service Provider</span>
                  </label>
                </div>
              </div>

              {registerData.role === "provider" && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <InputField label="Category*" name="category" value={registerData.category} onChange={handleChange} disabled={isLoading} />
                  </div>
                  
                  <div className="relative">
                    <label className="block text-gray-700 text-sm mb-1">Profile Image</label>
                    <input
                      type="file"
                      name="avatar"
                      accept="image/*"
                      onChange={handleChange}
                      className="w-full text-gray-700 text-sm file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-gray-100 file:text-green-700 hover:file:bg-gray-200"
                      disabled={isLoading}
                    />
                    {avatarPreview && (
                      <div className="absolute -top-4 right-0">
                        <img src={avatarPreview} alt="Preview" className="h-10 w-10 object-cover rounded-full border-2 border-green-500 shadow" />
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Submit Button */}
            <div className="col-span-4 mt-8">
              <button
                type="submit"
                className="w-full py-3 bg-green-700 text-white rounded-md font-semibold hover:bg-green-800 transition duration-150 shadow-md disabled:opacity-50"
                disabled={isLoading} // 🚨 Disable button while loading
              >
                {isLoading ? 'Registering...' : 'Signup'}
              </button>
            </div>

            {/* Login Link */}
            <div className="col-span-4 text-center mt-2">
              <p className="text-gray-700 text-sm">
                Already have an account?{" "}
                <Link to="/login" className={`text-green-700 hover:underline font-medium ${isLoading ? 'pointer-events-none' : ''}`}>
                  Login
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Register;

// ------------------- NEW LOADER COMPONENT -------------------

const FullScreenLoader = () => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-green-700 bg-opacity-90">
      <div className="flex flex-col items-center">
        {/* Spinner */}
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white mb-4"></div>
        <p className="text-white text-xl font-semibold">Loading...</p>
      </div>
    </div>
);


// ------------------- Reusable Components (Updated to accept `disabled` prop) -------------------

const InputField = ({ label, name, type = "text", value, onChange, disabled }) => (
  <div>
    <label className="block text-gray-700 text-sm mb-1">{label}</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled} // 🚨 Applied disabled prop
      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 disabled:bg-gray-100"
    />
  </div>
);

const PasswordField = ({ label, name, value, onChange, showPassword, togglePasswordVisibility, disabled }) => (
  <div className="relative">
    <label className="block text-gray-700 text-sm mb-1">{label}</label>
    <input
      type={showPassword ? "text" : "password"}
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled} // 🚨 Applied disabled prop
      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 pr-10 disabled:bg-gray-100"
    />
    <button
      type="button"
      onClick={() => togglePasswordVisibility(name)}
      className="absolute right-3 top-0 mt-8 text-gray-600 hover:text-green-700 disabled:opacity-50"
      disabled={disabled} // 🚨 Applied disabled prop
    >
      {showPassword ? <FaEyeSlash /> : <FaEye />}
    </button>
  </div>
);